import React from 'react';
import {Message} from 'epic-diesel-common';
import PropTypes from 'prop-types';
import Input from 'epic-diesel-form/src/components/form/Input';
import Select from 'epic-diesel-form/src/components/form/Select';
import {getMessage} from '../../common/Message';
import styles from './GuardianSection.pcss';
import signupStyles from '../../../pages/signup/SignUp.pcss';

import getInfluencersFlowSchema from '../../../data/InfluencersFlowSchema';

export default class GuardianSection extends React.Component {
    static propTypes = {
        messages: PropTypes.object,
        trigger: PropTypes.func,
        form: PropTypes.object
    };

    static defaultProps = {};

    getRelationship = () => {
        const {messages} = this.props;
        return [
            {
                value: '',
                label: `${getMessage(messages, 'epic.affiliate.signup.guardian.relationship')} *`
            },
            {
                value: 'father',
                label: `${getMessage(
                    messages,
                    'epic.affiliate.signup.guardian.relationship.father'
                )}`
            },
            {
                value: 'mother',
                label: `${getMessage(
                    messages,
                    'epic.affiliate.signup.guardian.relationship.mother'
                )}`
            },
            {
                value: 'other',
                label: `${getMessage(
                    messages,
                    'epic.affiliate.signup.guardian.relationship.other'
                )}`
            }
        ];
    };

    onChange = event => {
        const {name, value} = event.target;
        this.props.trigger(name, value);
    };

    render() {
        const {form, trigger, messages} = this.props;

        const schema = getInfluencersFlowSchema(getMessage, messages).signupInfo.guardian;

        return (
            <div className={signupStyles.header}>
                <h2>
                    <Message code="epic.affiliate.guardian.region.header" />
                    {' *'}
                </h2>
                <p>
                    <Message code="epic.affiliate.guardian.region.text" />
                </p>

                <div className={styles.content}>
                    <div className={styles.stateCityContainer}>
                        <div className={styles.stateContainer}>
                            <Input
                                name={schema.firstName.identifier}
                                value={form.firstName}
                                placeholder={schema.firstName.display.text}
                                validations={schema.firstName.validations}
                                validationErrors={schema.firstName.validationMessages}
                                required={true}
                                onChange={this.onChange}
                            />
                        </div>
                        <div className={styles.stateContainer}>
                            <Input
                                name={schema.lastName.identifier}
                                value={form.lastName}
                                placeholder={schema.lastName.display.text}
                                validations={schema.lastName.validations}
                                validationErrors={schema.lastName.validationMessages}
                                required={true}
                                onChange={this.onChange}
                            />
                        </div>
                        <div className={styles.stateContainer}>
                            <Select
                                name={schema.relationship.identifier}
                                value={form.relationship || ''}
                                required={true}
                                validations={schema.relationship.validations}
                                validationErrors={schema.relationship.validationMessages}
                                onChange={trigger}
                                options={this.getRelationship()}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
